import React from 'react'
import { ProductSummary } from '@screens/Marketplace/components/NewMarketplace/ProductSummary.tsx'
import StressManagementIcon from '@src/assets/svgs/stressManagement'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { useStressManagementOffering } from './useStressManagementOffering'

interface StressManagementProductSummaryProps {
  skipLoadingSchedulingInfo?: boolean
  showPrice?: boolean
  onPress: () => void
}

export const StressManagementProductSummary = ({
  skipLoadingSchedulingInfo = false,
  showPrice = false,
  onPress,
}: StressManagementProductSummaryProps) => {
  const { enabled, product, isMntOffering, error } = useStressManagementOffering({
    skipLoadingSchedulingInfo,
  })
  useLazyScreenPreload('StressManagementIntroScreen', {
    shouldPreload: enabled,
  })

  if (!enabled || error) {
    return null
  }

  const price = isMntOffering ? 0 : product?.price

  return (
    <ProductSummary
      title="Stress Management Call"
      description={`Reduce stress, boost well-being.${
        isMntOffering ? ' 95% of members are covered by insurance.' : ''
      }`}
      price={showPrice ? price : null}
      icon={<StressManagementIcon size={54} />}
      onPress={onPress}
      isInsuranceCovered={isMntOffering}
    />
  )
}
